<div class="upload-form" [formGroup]="form">
  <h2 class="title">{{ 'profile.document_information' | translate }}</h2>

  <app-upload-form [userId]="data.userId" [materialType]="MaterialType.OTHER" (uploaded)="onFileUploaded($event)"></app-upload-form>

  <div class="input-area">
    <div class="toggle-year-option">
      <app-button
        [label]="showYearField ? ('certificates_page.hide_year' | translate) : ('certificates_page.add_year' | translate)"
        [size]="ButtonSize.SMALL"
        [state]="ButtonState.REGULAR"
        [type]="ButtonType.PRIMARY"
        (click)="showYearField = !showYearField"
      ></app-button>
    </div>
    <label>{{ 'certificates_page.name' | translate }} ({{ 'optional' | translate }})</label>
    <app-input
      formControlName="certificationName"
      [placeholder]="'certificates_page.enter_name' | translate"
      [size]="InputSize.LARGER"
      [state]="InputState.REGULAR"
    ></app-input>

    <div class="input-area" *ngIf="showYearField">
      <label>{{ 'certificates_page.year' | translate }} ({{ 'optional' | translate }})</label>
      <app-input
        formControlName="certificationYear"
        [placeholder]="'certificates_page.enter_year' | translate"
        [size]="InputSize.LARGER"
        [state]="InputState.REGULAR"
      ></app-input>
    </div>
  </div>



  <div class="actions">
    <app-button
      [label]="'certificates_page.cancel' | translate"
      [size]="ButtonSize.LARGE"
      [state]="ButtonState.REGULAR"
      [type]="ButtonType.SECONDARY"
      (click)="onCancel()"
    ></app-button>

    <app-button
      [label]="'certificates_page.confirm' | translate"
      [size]="ButtonSize.LARGE"
      [state]="isFormValid ? ButtonState.REGULAR : ButtonState.DISABLED"
      [type]="ButtonType.PRIMARY"
      (click)="isFormValid && onSubmit()"
    ></app-button>
  </div>
</div>
